var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"h-full p-template-status__loader"},[_c('VLoadingSpinner',{attrs:{"size":"large"}})],1):_c('div',{staticClass:"p-template-update g-page h-full"},[_c('VDocumentSetup',{attrs:{"saving":_vm.saving,"doc":_vm.template,"fields":_vm.fields}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }